import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import _get from 'lodash/get';
import ButtonBase from '@material-ui/core/ButtonBase';
import { setClinicMode } from 'containers/Main/actions';
import { makeSelectClinicMode } from 'containers/Main/selectors';
import _classNames from 'classnames';
import useSiteCopySelector from 'components/useSiteCopySelector';
import AtTheClinicWhite from './images/atTheClinicWhite.svg';
import AtTheClinicDark from './images/atTheClinicDark.svg';

const useStyles = makeStyles({
  button: {
    backgroundColor: '#E3E3E3',
    color: '#9c9c9c',
    borderRadius: '15px',
    textTransform: 'none',
    width: '109px',
    height: '25px',
    fontFamily: 'MadaRegular',
    '& img': {
      marginRight: '5px',
      marginTop: '-3px',
    },
  },
  active: {
    backgroundColor: '#35A430',
    color: '#FFFFFF',
  },
});

const AtTheClinicButton = () => {
  const classes = useStyles();
  const clinicMode = useSelector(makeSelectClinicMode());
  const [assessmentSiteCopy] = useSiteCopySelector(['assessment']);
  const dispatch = useDispatch();

  const handleClick = () => {
    dispatch(setClinicMode(!clinicMode));
  };

  return (
    <ButtonBase
      className={_classNames({
        [classes.button]: true,
        [classes.active]: clinicMode,
      })}
      onClick={handleClick}
    >
      <img
        alt="clinicButton"
        src={clinicMode ? AtTheClinicWhite : AtTheClinicDark}
      />
      <span>{_get(assessmentSiteCopy, 'pageCopy.atTheClinicLabel')}</span>
    </ButtonBase>
  );
};

export default React.memo(AtTheClinicButton);
